import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/images/cod-logo.png'
import _imports_1 from '@/app/ui/assets/images/dfod-logo.png'


const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = {
  key: 0,
  class: "border-t-2"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "p-field-checkbox mt-3 ml-2 flex flex-row" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    class: "max-w-none w-16",
    alt: "cod-logo"
  }),
  /*#__PURE__*/_createVNode("label", {
    for: "cod",
    class: "mt-4 ml-2.5"
  }, "Cash on delivery")
], -1)
const _hoisted_6 = { class: "flex w-2/12 bg-gray-lp-200 py-4 rounded-md text-black-lp-300 justify-center mb-6 mt-4" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "p-field-checkbox mt-3 ml-2 mb-2 flex flex-row" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_1,
    class: "max-w-none w-16",
    alt: "cod-logo"
  }),
  /*#__PURE__*/_createVNode("label", {
    for: "cod",
    class: "mt-2 ml-2.5"
  }, "Delivery fee on delivery")
], -1)
const _hoisted_8 = { class: "grid grid-cols-2 border-t-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Title, { label: "Pengembalian STT return" }),
    _createVNode(_component_Title, {
      label: "Detail Penerima",
      fontSize: 14
    }),
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_DataWrapper, {
        class: "w-1/2",
        label: "Nama Penerima",
        value: _ctx.detailData.clientCodReject.clientCodName
      }, null, 8, ["value"])
    ]),
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_DataWrapper, {
        class: "w-1/2",
        label: "Alamat Penerima",
        value: _ctx.detailData.clientCodReject.clientCodAddress
      }, null, 8, ["value"])
    ]),
    _createVNode("div", _hoisted_3, [
      (_ctx.detailData.clientCodReject.clientCodDistrict)
        ? (_openBlock(), _createBlock(_component_DataWrapper, {
            key: 0,
            class: "w-1/2",
            label: "Kecamatan, Kota",
            value: `${_ctx.detailData.clientCodReject.clientCodDistrict.name || ''}`
          }, null, 8, ["value"]))
        : (_openBlock(), _createBlock(_component_DataWrapper, {
            key: 1,
            class: "w-1/2",
            label: "Kecamatan, Kota",
            value: '-'
          })),
      _createVNode(_component_DataWrapper, {
        class: "w-1/2",
        label: "No. Telepon",
        value: _ctx.detailData.clientCodReject.clientCodPhone
      }, null, 8, ["value"])
    ]),
    (_ctx.isEnableCodOngkir)
      ? (_openBlock(), _createBlock("div", _hoisted_4, [
          _createVNode(_component_Title, {
            label: "Tipe COD",
            fontSize: 14,
            class: "col-span-2 py-4"
          }),
          (_ctx.detailData.clientIsCod)
            ? (_openBlock(), _createBlock(_component_DataWrapper, {
                key: 0,
                class: "col-span-2"
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_6, [
            _createVNode("span", null, _toDisplayString(_ctx.detailData.clientCodConfigAmount.name), 1)
          ]),
          (_ctx.detailData.clientIsDfod)
            ? (_openBlock(), _createBlock(_component_DataWrapper, {
                key: 1,
                class: "col-span-2"
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_8, [
      _createVNode(_component_Title, {
        label: "Biaya & Persentase COD",
        fontSize: 14,
        class: "col-span-2 py-4"
      }),
      _createVNode(_component_DataWrapper, {
        label: "Biaya COD",
        value: `${_ctx.detailData.clientCodReject.clientCodCommission}%`
      }, null, 8, ["value"]),
      (_ctx.isEnableCodOngkir)
        ? (_openBlock(), _createBlock(_component_DataWrapper, {
            key: 0,
            label: "Persentase Diskon COD",
            value: _ctx.detailData.clientCodShipmentDiscount + '%'
          }, null, 8, ["value"]))
        : _createCommentVNode("", true),
      (_ctx.isEnableCodBooking)
        ? (_openBlock(), _createBlock(_component_DataWrapper, {
            key: 1,
            label: "Biaya PAD",
            value: `${_ctx.detailData.clientPadFee}%`
          }, null, 8, ["value"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}